<div class="rating-box">
    <img *ngIf="pollLevelIndicatorIcon" [src]="'assets/images/WaterqualityForecastIndicator/' + pollLevelIndicatorIcon" alt="forecast" class="rating-icon">
    <span class="rating-text"><strong>{{description ?? ""}}</strong></span>    
</div>